<template>
  <div class="product-comparison">
    <div class="container product-compare-header">
      <!-- {# Images #} -->
      <div class="row">
        <div v-for="product in products" class="col-6">
          <div class="product-compare-image bg-light">
            <div v-if="product">
              <div class="product-compare-actions">
                <button class="bg-transparent p-0 border-0 product-compare-remove" @click="removeProduct(product.product_id)">
                  <slot name="close-circle-icon" :product="product"></slot>
                </button>
              </div>
              <div class="bg-image-wrap">
                <img :src="product.image.src" :alt="product.image.alt" class="bg-image"/>
              </div>
            </div>

            <div v-if="!product">
              <div class="product-compare-actions">
                <button class="bg-transparent p-0 border-0 product-compare-add" @click="removeProduct(product.product_id)">
                  <slot name="plus-circle-icon" :product="product"></slot>
                </button>
              </div>
              <div class="product-compare-empty p-0 d-flex align-items-center justify-content-center">
                <slot name="product-compare-empty-top"></slot>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="product-compare-mobile-header bg-white">
      <div class="container">
        <!-- {# Base Details #} -->
        <div class="row d-lg-none">
          <div v-for="product in products" class="col-6">
            <div v-if="product" class="product-compare-base product-base pt-4">
              <h2 class="block-title product-title my-1" v-html="product.title"></h2>
              <div class="supertitle order-n1 product-series fw-bold">
                <span v-for="series in product.series" :class="'text-' + series.color">{{ series.title }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container product-compare-base-info">
      <div class="row">
        <div v-for="product in products" class="col-6">
          <div v-if="product" class="product-compare-base product-base pt-0 pt-lg-4 pb-4">
            <h2 class="d-none d-lg-block block-title product-title my-1" v-html="product.title"></h2>
            <div class="d-none d-lg-block supertitle product-series fw-bold">
              <span v-for="series in product.series" :class="'text-' + series.color">{{ series.title }}</span>
            </div>
            <div v-if="product.msrp_from" class="product-price fw-bold fs-large">
              <span class="d-none d-lg-inline"><slot name="product-compare-msrp-label"></slot> |</span> 
              <span class="d-lg-none"><slot name="product-compare-msrp-from"></slot></span> {{ product.msrp_from }} 
              <span v-if="product.msrp_to" class="d-none d-lg-inline">- {{ product.msrp_to }}</span>
            </div>
            <div v-if="product.isRatingEnabled" class="product-rating">
              <div data-bv-show="inline_rating" :data-bv-product-id="product.product_id"></div>
            </div>
            <div class="product-button" v-html="product.productDetailLink"></div>
          </div>
        </div>
      </div>

      <!-- {# Specs #} -->
      <div class="row mb-5">
        <div v-for="product in products" class="col-6">
          <div v-if="product" class="product-compare-specs">
            <h3 class="visually-hidden"><i class="fst-normal" v-html="product.title"></i> <slot name="product-compare-specification-suffix"></slot></h3>
            <div class="footnote-container" :id="'spec-fn-' + product.product_id">
              <table class="table table-striped product-spec-table">
                <tbody>
                  <tr v-for="spec in product.specs">
                    <td class="spec-label" v-html="spec.label"></td>
                    <td class="spec-value" v-html="spec.value"></td>
                  </tr>
                </tbody>
              </table>
              <div class="footnote-display"></div>
            </div>
          </div>
          <div v-if="!product" class="product-compare-specs">
            <div class="footnote-container" id="spec-fn">
              <table class="table table-striped product-spec-table">
                <tbody>
                  <tr v-for="i in Object.values(products).find((a) => a).specs.length">
                    <td class="spec-label">--</td>
                    <td class="spec-value">--</td>
                  </tr>
                </tbody>
              </table>
              <div class="footnote-display"></div>
            </div>
          </div>
        </div>
      </div>

      <h3 class="text-center d-lg-none block-title my-4"><slot name="product-compare-feature-mobile-title"></slot></h3>
    </div>

    <!-- Features -->
    <div class="bg-light py-2 py-lg-5 product-compare-features block">
      <div class="container">
        <!-- {# Features #} -->
        <div class="row">
          <div v-for="product in products" class="col-6">
            <div v-if="product" class="row">
              <div class="col-12 col-lg-10">
                <h3 class="h2 d-none d-lg-block block-title"><i class="fst-normal" v-html="product.title"></i> <slot name="product-compare-feature-title-suffix"></slot></h3>
                <dl class="my-4">
                  <template v-for="feature in product.features">
                    <dt class="fs-lg-6">{{ feature.title }}</dt>
                    <dd class="mb-4">{{ feature.description }}</dd>
                  </template>
                </dl>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return window.wf.productComparison
  },
  methods: {
    addProduct() {
      let params = new URLSearchParams();
      for (let key in this.products) {
        if (this.products[key]) {
          params.append('comparison_' + key, this.products[key].product_id)
        }
      }
      window.location = `${this.categoryUrl}?${params.toString()}`;
    },
    removeProduct(product_id) {
      if (Object.values(this.products).filter((a) => a).length <= 1) {
        window.location = this.categoryUrl;
        return;
      }
      for (let key in this.products) {
        if (this.products[key] && this.products[key].product_id == product_id) {
          this.products[key] = null;
        }
      }
    }
  }
}
</script>
